<template>
  <div>
    <div v-if="tipoImport === 'citas'">
      Manual para importar citas
    </div>
    <div v-if="tipoImport === 'escuelas'">
      Manual para importar escuelas
    </div>
    <div class="md-layout md-alignment-center-center">
      <md-card style="min-width:350px; !important">
        <md-card-header>
          <div class="md-title">
            {{'Importar '+tipoImport}}
          </div>
        </md-card-header>
        <md-card-content>
          <md-field>
            <label>Archivo CSV</label>
            <md-file
              v-model="file"
              @md-change="addFile($event)"
              accept=".csv"
            />
          </md-field>
        </md-card-content>
        <md-card-actions v-if="file">
          <md-button
            class="md-primary md-raised"
            @click="_subir"
          >Importar archivo</md-button>
        </md-card-actions>
      </md-card>
    </div>
    <md-dialog
      :md-active.sync="cargando"
      :md-close-on-esc="false"
      :md-click-outside-to-close="false"
    >
      <md-dialog-title class="text-center">Importando {{tipoImport}}</md-dialog-title>
      <md-card-content class="text-center">
        <md-progress-spinner
          :md-diameter="100"
          :md-stroke="10"
          md-mode="indeterminate"
        />
        <p>Espere un mometo</p>
      </md-card-content>
    </md-dialog>
  </div>
</template>
<script>
export default {
  data() {
    return {
      tipoImport: "",
      file: null,
      selectedFile: null,
      cargando: false
    };
  },
  methods: {
    addFile(e) {
      this.selectedFile = e[0];
    },
    _subir() {
      var formData = new FormData();
      formData.append("archivo", this.selectedFile);
      this.cargando = true;
      this.$http
        .post("importar/" + this.tipoImport, formData, this.$headers)
        .then(
          res => {
            this.cargando = false;
            if (res.status === 401) {
              this.$router.push("/login");
            } else if (res.status === 201) {
              this.$emit(
                "msg",
                "Las " + this.tipoImport + " han sido importadas correctamente"
              );
            } else {
              this.$emit(
                "msg",
                "Sucedió un error al importar las " + this.tipoImport
              );
            }
          },
          err => {
            this.cargando = false;
            this._falloResponse(err);
          }
        );
    },
    _checkRoute() {
      this.tipoImport = this.$route.params.tipo;
      if (this.tipoImport === "citas" || this.tipoImport === "escuelas") {
      } else {
        this.$router.push("/");
      }
    }
  },
  created() {
    this._checkRoute();
  },
  beforeCreate() {
    if (!this.$session.exists() && !this.$session.get("tipo")) {
      this.$emit("visible", false);
      this.$router.push("/login");
    } else {
      this.$emit("visible", true);
      this.$emit("classes", "container");
    }
  },
  watch: {
    $route: {
      deep: true,
      immediate: true,
      handler: "_checkRoute"
    }
  }
};
</script>